

import {Component, Mixins, Ref, Watch} from "vue-property-decorator";
import GenelIslemFormWizard, {GenelIslemEntity} from "@/components/forms/form-wizard/eicrapro/GenelIslemFormWizard.vue";
import SimpleInputMixin from "@/mixins/SimpleInputMixin.vue";
import FormDialog from "@/components/dialogs/FormDialog.vue";
import EvrakEkleForm from "@/components/eicrapro/EvrakEkleForm.vue";
import {Task} from "@/plugins/uyap-plugin/store/modules/GorevYoneticisiTypes";
import {TaskTuru} from "@/plugins/uyap-plugin/enum/TaskTuru";
import PersonelPicker from "@/components/pickers/PersonelPicker.vue";
import {VForm} from "@/types";
import FormButton from "@/components/dialogs/FormButton.vue";
import GonderilecekEvrakList from "@/components/lists/GonderilecekEvrakList.vue";
import {ProgramPaths} from "@/enum/ProgramPaths";

@Component({
  components: {GonderilecekEvrakList, FormButton, PersonelPicker, EvrakEkleForm, FormDialog, GenelIslemFormWizard}
})

export default class EvrakGonderFormWizard extends Mixins(SimpleInputMixin) {
  @Ref('form') readonly form!: VForm;
  @Ref('genel-form') genelForm!: GenelIslemFormWizard;

  localValue: GenelIslemEntity = new GenelIslemEntity();
  valid = false;
  onFly = false;
  uploadTotalSteps = 0;
  uploadCompletedSteps = 0;
  /** true: dosya yüklemesi bitti, postTasks / sıra aşaması (indeterminate çubuk) */
  uploadQueuePhase = false;

  get uploadProgressPercent(): number {
    if (this.uploadTotalSteps <= 0) {
      return 0;
    }
    return Math.round((this.uploadCompletedSteps / this.uploadTotalSteps) * 100);
  }

  get uploadStatusMessage(): string {
    return 'Görevler sıraya alınıyor...';
  }
  stepperHeaders = [
    "Listelenecek Takipler",
    "Takipleri Seç",
    "Evrak Gönder",
    "İşlemler Sıraya Alındı"
  ];
  secilenHeaders = [
    {text: "Birim Adı", value: "birimAdi"},
    {text: "Dosya Esas No", value: "dosyaNo"},
    {text: "Açılış Tarihi", value: "acilis_tarihi"},
    {text: "Dosya Durumu", value: "dosyaDurumAciklama"},
    {text: "İşlemler", value: "actions", align: 'center', sortable: false}
  ];

  @Watch('localValue.secilen_takipler')
  onTakiplerChange() {
    this.localValue.secilen_takipler.forEach(takip => {
      // @ts-ignore
      if (!takip.evraklar) {
        // @ts-ignore
        takip.evraklar = [];
        this.input();
      }
    })
  }

  onAddAll(event: any) {
    this.localValue.secilen_takipler.forEach((takip: any) => {
      if (takip.evraklar && takip.evraklar.length > 0) {
        takip.evraklar.push(event);
      } else {
        takip.evraklar = [];
        takip.evraklar.push(event);
      }
    })
    this.input();
  }

  // dosya kaydetme hatası düzeltilene kadar kaldırma
  waitThisLong(saniye: number) {
    return new Promise(resolve => setTimeout(resolve, saniye * 1000))
  }

  countFileUploadSteps(): number {
    let n = 0;
    for (const takip of this.localValue.secilen_takipler) {
      // @ts-ignore
      const evraklar = takip.evraklar || [];
      for (const evrak of evraklar) {
        n += 1;
        // @ts-ignore
        const ekler = evrak.ekDosyalarData || [];
        n += ekler.length;
      }
    }
    return n;
  }

  resetUploadProgress(): void {
    this.uploadTotalSteps = 0;
    this.uploadCompletedSteps = 0;
    this.uploadQueuePhase = false;
  }

  async createTask() {
    if (!this.form.validate()) {
      return;
    }
    const totalSteps = this.countFileUploadSteps();
    this.uploadTotalSteps = totalSteps;
    this.uploadCompletedSteps = 0;
    this.uploadQueuePhase = totalSteps === 0;
    this.onFly = true;
    try {
      let tasks: Array<Task> = [];
      for (let takip of this.localValue.secilen_takipler) {
        // @ts-ignore
        for (let evrak of takip.evraklar) {
          let formData = new FormData();
          formData.append('aciklama', evrak.aciklama);
          formData.append('name', evrak.dosyaData.name);
          formData.append('file', evrak.dosyaData.dosya, evrak.dosyaData.name || 'evrak');
          formData.append('hash', evrak.dosyaData.hash);
          formData.append('mime_type', evrak.dosyaData.type);
          let evrakResponse = await this.$http.post('/api/v1/file', formData);
          evrak.dosyaData.file_res = evrakResponse.data;
          evrak.dosyaData.base64 = null;
          this.uploadCompletedSteps += 1;
          // dosya kaydetme hatası düzeltilene kadar kaldırma
          await this.waitThisLong(1);
          for (let ekEvrak of evrak.ekDosyalarData) {
            let formDataEk = new FormData();
            formDataEk.append('aciklama', ekEvrak.aciklama);
            formDataEk.append('name', ekEvrak.name);
            formDataEk.append('file', ekEvrak.dosya, ekEvrak.name || 'ek');
            formDataEk.append('hash', ekEvrak.hash);
            formDataEk.append('mime_type', ekEvrak.type);
            let ekEvrakResponse = await this.$http.post('/api/v1/file', formDataEk);
            ekEvrak.file_res = ekEvrakResponse.data;
            ekEvrak.base64 = null;
            this.uploadCompletedSteps += 1;
            // dosya kaydetme hatası düzeltilene kadar kaldırma
            await this.waitThisLong(1);
          }
        }
        let task: Task = new Task();
        task.dosya_esas_no = takip.dosyaNo;
        task.birim_adi = takip.birimAdi;
        task.dosya_id = takip.dosyaId;
        task.birim_id = takip?.birimId;
        task.uyap_dosya_acilis_tarihi = takip.dosyaAcilisTarihi ? new Date(this.$uyapHelper.formatDate(takip.dosyaAcilisTarihi)).toString() : "";
        task.task_type_id = TaskTuru.evrak_gonder;
        //@ts-ignore
        task.data = takip.evraklar;
        tasks.push(task);
      }
      this.uploadQueuePhase = true;
      let res = await this.$store.dispatch('postTasks', tasks);
      if (this.$store.getters.getAutoPlay)
        await this.$router.push(ProgramPaths.eicrapro + '/evrak-gonder-detay/' + res.data.id);
      else
        await this.$router.push(ProgramPaths.eicrapro + '/islemler');
    } catch (e: any) {
      const msg = e && e.message ? String(e.message) : 'Bilinmeyen hata';
      this.$toast.error('Evrak gönderimi sırasında bir hata oluştu: ' + msg);
    } finally {
      this.onFly = false;
      this.resetUploadProgress();
    }
  }
}
